import { events } from './events';
import { Module } from './framework/module';
import { PlEvent } from './models/pl.event';

export class PlModule extends Module {
  constructor() {
    super({});
  }

  async onInit(): Promise<void> {
    events.on('source-selected', () =>
      dispatchEvent(
        new PlEvent({
          goal: 'selected source',
        })
      )
    );

    events.on('recording-finished', () =>
      dispatchEvent(
        new PlEvent({
          goal: 'finished recording',
        })
      )
    );

    events.on('start-recording', () =>
      dispatchEvent(
        new PlEvent({
          goal: 'started recording',
        })
      )
    );

    events.on('start-delayed-recording', () =>
      dispatchEvent(
        new PlEvent({
          goal: 'started delayed recording',
        })
      )
    );

    events.on('user-denied-access', () =>
      dispatchEvent(
        new PlEvent({
          goal: 'user denied access',
        })
      )
    );

    events.on('recording-cancelled', () =>
      dispatchEvent(
        new PlEvent({
          goal: 'recording cancelled',
        })
      )
    );
  }
}
